import React, { Component } from 'react';
import { Button } from '@blueprintjs/core';

const leadLineStyle = {
	width: '600px',
	margin: '40px',
	padding: '10px',
	border: '1px solid black'
};

class LeadsLine extends Component {

	render() {
		//console.log(this.props.lead);

		return (
			<div style={leadLineStyle}>

				<div> Company Name: {this.props.lead.companyName} </div>
				<div> Contact First Name: {this.props.lead.contactFirstName} </div>
				<div> Contact Last Name: {this.props.lead.contactLastName} </div>

				<div> Entered On: {this.props.lead.enteredDate} </div>
				<div> Due Date: {this.props.lead.dueDate} </div>
				<div> Last Contact: {this.props.lead.lastContactDate} </div>

				<div> Phone: {this.props.lead.contactPhone} </div>
				<div> Email: {this.props.lead.contactEmail} </div>

				<div> Action Item: {this.props.lead.actionItem} </div>
				<div> Contact Notes: {this.props.lead.contactNotes} </div>
				<div> Details: {this.props.lead.details} </div>

				<div> Complete: {this.props.lead.complete} </div>

				<Button onClick={this.edit}>
					Edit
				</Button>

				<Button icon="edit" onClick={this.edit} />

			</div>
		);
	}

	edit = () => {
		const { lead, gotoEditLead } = this.props;
		gotoEditLead(lead);
	}

}
export default LeadsLine;


// WEBPACK FOOTER //
// ./src/components/leadtracker/LeadsLine.js